import React from 'react';

import useWindowSize from 'shared/hooks/useWindowResize';
import breakpoints from 'theme/atoms/breakpoints';
import EventPage from 'events/pages/EventPage';
import EventsHomePage from 'events/pages/EventsHomePage';

interface EventRoutePageProps {
  eventId?: string;
}

export default function EventRoutePage({
  eventId,
}: EventRoutePageProps): JSX.Element {
  const [windowWidth] = useWindowSize();
  const isDesktopView = windowWidth > parseInt(breakpoints.laptop, 10);

  if (eventId && !isDesktopView) return <EventPage eventId={eventId} />;

  return <EventsHomePage />;
}
